export default __webpack_public_path__ + "static/media/teladivisortensao.7b838033.png";